module.exports = __webpack_public_path__ + "assets/partnership-bg-4.a2008cbf.jpg";